/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const CustomTextField = styled(
  forwardRef((props: any, ref: React.Ref<any>) => {
    const mergedInputProps = { dir: 'auto', ...(props.inputProps || {}) };
    return <TextField ref={ref} {...props} inputProps={mergedInputProps} />;
  }),
)(({ theme }) => ({
  '& .MuiOutlinedInput-input::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '0.8',
  },
  '& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '1',
  },
  '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[200],
  },
}));

CustomTextField.displayName = 'CustomTextField';

export default CustomTextField;
